/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { useStateValue } from "../../context/store";
import {
  Grid,
  TextField,
  FormControl,
  Typography,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  Button,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { styles } from "./styles";
import { getMaestras } from "../../actions/maestras-actions";
import { getActiveRegionals } from "../../actions/regional-actions";
import { defaultValues, remunerValidate } from "./models";
import { getById } from "../../actions/user-actions";
import { getEmployeeData } from "../../actions/permissions-actions";
import { REQUIRED_MESSAGE } from "../../constants";
import { getCharges } from "../../actions/charge-actions";
import Utils from "../../utils/utils";
import moment from "moment";

const PermissionsForm = ({
  handleOpen,
  onSubmit,
  isMinToHour,
  GetDuration,
  setIsMinToHour,
}) => {
  const [{ sessionUser }, dispatch] = useStateValue();
  const _ = require("lodash");
  const classes = styles();
  const [isDisabled, setIsDisabled] = useState(false);
  const [regionales, setRegionales] = useState([]);
  const [maestras, setMaestras] = useState({
    estadoCivil: [],
    generos: [],
    nivelFormacion: [],
    respuestaAfirmacionNegacion: [],
    tallaCalzado: [],
    tallaLetras: [],
    tallaNumerosFemenino: [],
    tallaNumerosMasculino: [],
    tipoDocumnetoIdentificacion: [],
  });

  const [minDate, setMinDate] = useState(null);

  const [charges, setCharges] = useState([]);
  const [resetForm, setResetForm] = useState(defaultValues);
  var currentDate = new Date();
  currentDate.setMinutes(
    currentDate.getMinutes()
    // + currentDate.getTimezoneOffset()
  );
  const [maxInitDate, setMaxInitDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  const [maxDate, setMaxDate] = useState(null);
  const [dateError, setDateError] = useState(false);
  const [messageInvalidDate, setMessageInvalidDate] = useState("");
  const [minDateError, setMinDateError] = useState(false);

  useEffect(() => {
    if (dateError) {
      setMessageInvalidDate("Ingrese una fecha válida");
    } else if (isMinToHour) {
      setMessageInvalidDate(
        "Seleccione una duración de permiso mayor a 1 hora"
      );
    } else if (dateError && isMinToHour) {
      setMessageInvalidDate("Ingrese una fecha válida");
    } else {
      setMessageInvalidDate("");
    }
  }, [dateError, isMinToHour]);

  useEffect(() => {
    getListaMaestras();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Permisos",
      breadCrumbSubText: "Tramitar permiso de empleado",
      index: 19,
    });
  }, []);

  const onChangeValues = (e) => {
    const { name, value } = e.target;
    setResetForm({ ...resetForm, [name]: value });
  };

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  useEffect(() => {
    const getAllCharges = async () => {
      const response = await getCharges();
      setCharges(response?.data?.chargeList);
    };
    getAllCharges();
  }, []);

  const schema = yup.object().shape({
    firstName: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    secondName: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    surname: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    secondSurname: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    documentType: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    documentNumber: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    charge: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    duration: yup.string().nullable().notRequired(REQUIRED_MESSAGE),
    typePermission: yup.string().nullable().required(REQUIRED_MESSAGE),
    description:
      resetForm.description === null
        ? null
        : yup
            .string()
            .nullable()
            .notRequired(REQUIRED_MESSAGE)
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(150, "Ingrese máximo 150 caracteres"),
    initDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .required(REQUIRED_MESSAGE),
    initTime: yup.string().typeError("Hora inválida").nullable().required(REQUIRED_MESSAGE),
    endDate: yup
      .date()
      .typeError("Fecha inválida")
      .nullable()
      .required(REQUIRED_MESSAGE),
    endTime: yup.string().typeError("Hora inválida").nullable().required(REQUIRED_MESSAGE),
    remuner: yup.string().nullable().required(REQUIRED_MESSAGE),
    regional: yup.string().nullable().notRequired(),
    applicationDate: yup.date().nullable().required(REQUIRED_MESSAGE),
    observations: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(500, "Ingrese máximo 500 caracteres"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    watch,
    trigger
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "all",
    reValidateMode: "onChange",
  });

  // 1.
  const getPersonByDocAndType = (docType, document) => {
    const getPerson = async (doc, number) => {
      const personResponse = await getEmployeeData(number, doc, dispatch);
      const personData = personResponse.data;
      setPersonData(personData);
    };
    getPerson(docType, document);
  };

  useEffect(() => {
    let personResponse = null;

    const getPerson = async () => {
      const data = JSON.parse(localStorage.getItem("state"));
      let personId = sessionUser && sessionUser.userInfo.person.id;
      let id = personId ? personId : data.userInfo.person.id;
      personResponse = await getById(id, dispatch);

      getPersonByDocAndType(
        personResponse.data.documentType,
        personResponse.data.documentNumber
      );
    };

    getPerson();
  }, []);

  const setPersonData = (data) => {
    setValue("firstName", data.firstName);
    setValue("secondName", data.secondName);
    setValue("surname", data.surname);
    setValue("secondSurname", data.secondSurname);
    setValue("documentType", data.documentType);
    setValue("documentNumber", data.document);
    setValue("charge", data?.charge?.id);
    setValue("regional", data?.regional?.id);
  };

  const onChangeDate = (value) => {
    var currentData = getValues();
    if (currentData?.initTime) {
      const [hours, minutes] = currentData?.initTime
        .split(":")
        .map((part) => parseInt(part));
      value.setHours(hours);
      value.setMinutes(minutes);
    } else {
      value.setHours(0);
      value.setMinutes(0);
    }
    setMinDate(value);
    if (
      currentData?.endDate &&
      currentData.endDate.getTime() < value.getTime()
    ) {
      setValue("duration", null);
      setMinDateError(true);
      setIsMinToHour(true);
      return;
    } else {
      setMinDateError(false);
      setIsMinToHour(false);
      if (value && currentData?.endDate) {
        setValue("duration", durationAsString(value, currentData?.endDate));
        trigger("duration");
      }
    }
  };

  const onChangeInitTime = (e) => {
    const value = e.target.value;
    var currentData = getValues();
    setValue("initTime", value);
    if (currentData.initDate !== null && !isNaN(currentData.initDate) && value) {
        const [hours, minutes] = value.split(":").map((part) => parseInt(part));
        currentData.initDate.setHours(hours);
        currentData.initDate.setMinutes(minutes);
        setMinDate(currentData.initDate);
    }
    if (
      currentData?.endDate && currentData?.initDate &&
      currentData?.endDate.getTime() < currentData?.initDate.getTime()
    ) {
        setIsMinToHour(true);
        setValue("duration", null);
        return;
    } else {
      setMinDateError(false);
      setIsMinToHour(false);
      if (value && currentData.initDate && currentData?.endDate && currentData?.endTime) {
        setValue("duration", durationAsString(currentData?.initDate, currentData?.endDate));
        trigger("duration");
      } else {
        setValue("duration", null);
      }
    }
  };

  const updateMaxInitDate = (finishDate) => {
    var currentData = getValues();
    if (currentData?.endTime) {
      const [hours, minutes] = currentData?.endTime
        .split(":")
        .map((part) => parseInt(part));
        finishDate.setHours(hours);
        finishDate.setMinutes(minutes);
    } else {
      finishDate.setHours(23);
      finishDate.setMinutes(59);
    }
    if (
      currentData?.initDate &&
      currentData.initDate.getTime() > finishDate.getTime()
    ) {
        setIsMinToHour(true);
        setValue("duration", null);
        return;
    } else {
      setIsMinToHour(false);
      if (currentData?.endTime && currentData.initDate && finishDate) {
        setValue("duration", durationAsString(currentData?.initDate, finishDate));
        trigger("duration");
      } else {
        setValue("duration", null);
      }
    }

    if (!currentData.initDate) {
      setMaxInitDate(finishDate);
    } else {
      setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
    }
  };

  const onChangeEndTime = (e) => {
    const value = e.target.value;
    var currentData = getValues();
    setValue("endTime", value);
    if (currentData.endDate !== null && !isNaN(currentData.endDate) && value) {
      const [hours, minutes] = value.split(":").map((part) => parseInt(part));
      currentData.endDate.setHours(hours);
      currentData.endDate.setMinutes(minutes);
    }
    if (
      value && currentData?.initDate &&
      currentData?.endDate
    ) {
      if (currentData?.initDate.getTime() > currentData?.endDate.getTime()) {
        setIsMinToHour(true);
        setValue("duration", null);
        return;
      } else {
        if (value && currentData?.initDate && currentData?.endDate) {
          setIsMinToHour(false);
          setValue("duration", durationAsString(currentData?.initDate, currentData?.endDate));
          trigger("duration");
        } else {
          setValue("duration", null);
          setIsMinToHour(true);
        }
      }
    } else {
      setValue("duration", null);
    }

    if (!currentData.initDate) {
      setMaxInitDate(currentData.endDate);
    } else {
      setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
    }
  };

  function durationAsString(start, end) {
    const duration = moment.duration(moment(end).diff(moment(start)));

    //Get Days
    const days = Math.floor(duration.asDays()); // .asDays returns float but we are interested in full days only
    const daysFormatted = days ? `${days} dias ` : ""; // if no full days then do not display it at all

    //Get Hours
    const hours = duration.hours();
    const hoursFormatted = `${hours} horas `;

    //Get Minutes
    const minutes = duration.minutes();
    const minutesFormatted = `${minutes}m`;

    return [daysFormatted, hoursFormatted].join("");
  }

  const validateMaxInitDate = () => {
    var currentData = getValues();
    if (!currentData.endDate) {
      setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
    } else {
      setMaxDate(currentData.endDate);
      setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
    }
  };

  const displayDescription = watch("typePermission") === "OTHER";
  const startDate = watch("initDate");
  const finalDate = watch("endDate");
  const startTime = watch("initTime");
  const finalTime = watch("endTime");

  useEffect(() => {
    if (startDate !== null && finalDate !== null) {
      const startD = new Date(startDate);
      const finalD = new Date(finalDate);
      const dateObj = GetDuration(startD, finalD);
      if (dateObj?.hasOwnProperty("zero")) {
        setIsMinToHour(true);
      } else {
        setIsMinToHour(false);
      }
    }
  }, [startDate, finalDate, startTime, finalTime]);

  const handleNumberKeyPress = (e) => {
    let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    if (!validChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <form
        id="generatePermission"
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
      >
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Primer nombre"
                name="firstName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
                helperText={
                  errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Segundo nombre"
                name="secondName"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
                helperText={
                  errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Primer apellido"
                name="surname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("surname") &&
                  errors["surname"].message
                }
                helperText={
                  errors.hasOwnProperty("surname") && errors["surname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                label="Segundo apellido"
                name="secondSurname"
                size="small"
                disabled={true}
                InputLabelProps={{ shrink: true }}
                error={
                  !!errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
                helperText={
                  errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("documentType") &&
                errors["documentType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de Documento
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Tipo de Documento"
                name="documentType"
                disabled={true}
                size="small"
                notched={true}
                onChange={(event) => alert(event.target.value)}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  name: "documentType",
                  id: "outlined-select-documentType",
                }}
                as={
                  <Select>
                    {maestras.tipoDocumnetoIdentificacion.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={document.key}
                        value={document.key}
                      >
                        {document.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
                label="Número de Documento"
                name="documentNumber"
                size="small"
                error={
                  !!errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
                helperText={
                  errors.hasOwnProperty("documentNumber") &&
                  errors["documentNumber"].message
                }
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("charge") && errors["charge"].message
              }
            >
              <InputLabel htmlFor="outlined-select-charge" shrink={true}>
                Cargo Solicitante *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                size="small"
                name="charge"
                label="Cargo solicitante *"
                notched={true}
                disabled={true}
                className={classes.formField}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  name: "stateId",
                  id: "outlined-select-charge",
                }}
                as={
                  <Select>
                    {charges.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("gender") && errors["gender"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                defaultValue={null}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                  },
                }}
                disabled={true}
                InputLabelProps={{ shrink: true }}
                style={{ backgroundColor: "#ffffff" }}
                label="Duración del permiso *"
                name="duration"
                size="small"
                FormHelperTextProps={{
                  style: {
                    backgroundColor: "#e0f1f8",
                    width: "100%",
                    marginLeft: "0px",
                    marginTop: "0px",
                    paddingTop: "4px",
                  },
                }}
                error={
                  !!errors.hasOwnProperty("duration") &&
                  errors["duration"].message
                }
                helperText={
                  errors.hasOwnProperty("duration") &&
                  errors["duration"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    InputProps={{ readOnly: true }}
                    style={{ backgroundColor: "#ffffff" }}
                    format="dd/MM/yyyy"
                    label="Fecha de inicio *"
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    onAccept={onChangeDate}
                    onChange={onChangeDate}
                    onOpen={validateMaxInitDate}
                    error={
                      !isDisabled &&
                      !!errors.hasOwnProperty("initDate") &&
                      errors["initDate"].message
                    }
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    helperText={
                      !isDisabled &&
                      errors.hasOwnProperty("initDate") &&
                      errors["initDate"].message
                    }
                    minDate={new Date()}
                    maxDate={maxDate ? maxDate : "01.01.2099"}
                  />
                }
                control={control}
                name="initDate"
                defaultValue={null}
                placeholder="Fecha de inicio *"
                size="small"
              />
              {minDateError && (
                <FormHelperText
                  className={classes.helperText}
                  style={{ color: "#f44336" }}
                >
                  {"Ingrese una fecha valida"}
                </FormHelperText>
              )}
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="time"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  style: {
                    height: "10px",
                    borderRadius: "2px",
                    paddingBottom: "11.5px",
                    paddingTop: "12px",
                    fontSize: 14,
                  },
                }}
                InputLabelProps={{ shrink: true }}
                label="Hora inicio *"
                name="initTime"
                size="small"
                onAccept={onChangeInitTime}
                onChange={onChangeInitTime}
                onKeyPress={handleNumberKeyPress}
                oninvalid="this.setCustomValidity('El mensaje que se desea mostrar')"
                error={
                  !!errors.hasOwnProperty("initTime") &&
                  errors["initTime"].message
                }
                FormHelperTextProps={{
                  style: {
                    backgroundColor: "#e0f1f8",
                    width: "100%",
                    marginLeft: "0px",
                    marginTop: "0px",
                    paddingTop: "4px",
                  },
                }}
                helperText={
                  errors.hasOwnProperty("initTime") &&
                  errors["initTime"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    InputProps={{ readOnly: true }}
                    variant="inline"
                    style={{ backgroundColor: "#ffffff" }}
                    format="dd/MM/yyyy"
                    onAccept={updateMaxInitDate}
                    onChange={updateMaxInitDate}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    label="Fecha de finalización *"
                    InputLabelProps={{ shrink: true }}
                    error={
                      !isDisabled &&
                      !!errors.hasOwnProperty("endDate") &&
                      errors["endDate"].message
                    }
                    FormHelperTextProps={{
                      style: {
                        backgroundColor: "#e0f1f8",
                        width: "100%",
                        marginLeft: "0px",
                        marginTop: "0px",
                        paddingTop: "4px",
                      },
                    }}
                    helperText={
                      !isDisabled &&
                      errors.hasOwnProperty("endDate") &&
                      errors["endDate"].message
                    }
                    minDate={minDate ? minDate : currentDate}
                    //maxDate={maxDate}
                  />
                }
                control={control}
                className={classes.formField}
                defaultValue={null}
                name="endDate"
                placeholder="Fecha de finalización *"
                size="small"
              />

            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="time"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  style: {
                    height: "10px",
                    borderRadius: "2px",
                    paddingBottom: "11.5px",
                    paddingTop: "12px",
                    fontSize: 14,
                  },
                }}
                InputLabelProps={{ shrink: true }}
                label="Hora fin *"
                name="endTime"
                size="small"
                onAccept={onChangeEndTime}
                onChange={onChangeEndTime}
                onKeyPress={handleNumberKeyPress}
                error={
                  !!errors.hasOwnProperty("endTime") &&
                  errors["endTime"].message
                }
                FormHelperTextProps={{
                  style: {
                    backgroundColor: "#e0f1f8",
                    width: "100%",
                    marginLeft: "0px",
                    marginTop: "0px",
                    paddingTop: "4px",
                  },
                }}
                helperText={
                  errors.hasOwnProperty("endTime") && errors["endTime"].message
                }
              />
            </FormControl>
            {messageInvalidDate && (
                <FormHelperText
                  className={classes.helperText}
                  style={{ color: "#f44336" }}
                >
                  {messageInvalidDate}
                </FormHelperText>
              )}
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                style={{ backgroundColor: "#e0e0e0" }}
                as={
                  <KeyboardDateTimePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy HH:mm"
                    onAccept={onChangeDate}
                    inputProps={{
                      style: {
                        height: "18px",
                        borderRadius: "8px",
                        paddingBottom: "6.5px",
                        fontSize: 14,
                      },
                    }}
                    label="Fecha de solicitud"
                    InputLabelProps={{ shrink: true }}
                  />
                }
                control={control}
                className={classes.formField}
                disabled={true}
                name="applicationDate"
                value={Date.Now}
                placeholder="Fecha de solicitud"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regional") &&
                errors["regional"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regional" shrink={true}>
                Regional *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Regional *"
                size="small"
                name="regional"
                style={{ backgroundColor: "#ffffff" }}
                notched={true}
                disabled={true}
                inputProps={{
                  name: "shoeSize",
                  id: "outlined-select-regional",
                }}
                as={
                  <Select>
                    {regionales.map((op) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={op.id}
                        value={op.id}
                      >
                        {op.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("regional") &&
                  errors["regional"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("typePermission") &&
                errors["typePermission"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-typePermission"
                shrink={true}
              >
                Tipo de permiso *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                size="small"
                name="typePermission"
                label="Tipo de permiso *"
                notched={true}
                className={classes.formField}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  name: "typePermission",
                  id: "outlined-select-typePermission",
                }}
                as={
                  <Select>
                    {maestras?.tipoPermiso?.map((typePermission) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={typePermission?.clave}
                        value={typePermission?.clave}
                      >
                        {typePermission?.valor}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("typePermission") &&
                  errors["typePermission"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            lg={3}
            style={{ display: displayDescription ? "none" : "inline" }}
          ></Grid>

          <Grid
            item
            xs={12}
            md={3}
            lg={3}
            style={{ display: !displayDescription ? "none" : "inline" }}
          >
            <FormControl fullWidth>
              <TextField
                fullWidth
                type="text"
                variant="outlined"
                inputRef={register}
                className={classes.formField}
                onChange={onChangeValues}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "6.5px",
                    fontSize: 14,
                    backgroundColor: "#ffffff",
                  },
                }}
                InputLabelProps={{ shrink: true }}
                label="Descripción"
                name="description"
                defaultValue=""
                size="small"
                error={
                  resetForm.description === null
                    ? null
                    : !!errors.hasOwnProperty("description") &&
                      errors["description"].message
                }
                helperText={
                  resetForm.description === null
                    ? null
                    : !!errors.hasOwnProperty("description") &&
                      errors["description"].message
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("remuner") && errors["remuner"].message
              }
            >
              <InputLabel htmlFor="outlined-select-remuner" shrink={true}>
                Remuneración *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.formField}
                label="Remuneracion *"
                size="small"
                name="remuner"
                notched={true}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{
                  name: "pantSize",
                  id: "outlined-select-remuner",
                }}
                as={
                  <Select>
                    {remunerValidate.map((remunerValidate) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={remunerValidate}
                        value={remunerValidate}
                      >
                        {remunerValidate}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText>
                {errors.hasOwnProperty("remuner") && errors["remuner"].message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="subtitle2">
              Señor Usuario tenga en cuenta que los permisos No remunerados son
              aquellos que serán descontados de la nómina, y los remunerados son
              aquellos que no afectan la nómina.
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={2}>
          <Button
            style={{
              marginBottom: "30px",
              marginTop: "20px",
              backgroundColor: "#7EBDCE",
              color: "#ffffff",
            }}
            onClick={handleOpen}
          >
            USUARIO APROBADOR
          </Button>
        </Grid>

        <Grid item xs={12} md={12} lg={12}>
          <FormControl fullWidth>
            <TextField
              fullWidth
              variant="outlined"
              inputRef={register}
              className={classes.notes}
              label="Obervación *"
              name="observations"
              placeholder="Observación"
              multiline
              rows={3}
              rowsMax={3}
              InputLabelProps={{ shrink: true }}
              error={
                !!errors.hasOwnProperty("observations") &&
                errors["observations"].message
              }
            />
            <FormHelperText style={{ color: "#f44336" }}>
              {errors.hasOwnProperty("observations") &&
                errors["observations"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
      </form>
    </React.Fragment>
  );
};

export default withRouter(PermissionsForm);
